<template>
	<div class="container immerse-wrap">
		<div class="immerse-content">
			<div :class="isFinishedOrderModal === true ? 'addFullscreen' : ''"></div>
			<StepBar :step="1" />
			<div class="pickUp-method-wrapper" @click="handlePickupMethodClick">
				<div
					class="pickUp-method-displayer"
					:class="{ '--method-exist': pickUpMethodExist }"
				>
					<div class="pickUp-method-displayer-text-wrapper">
						<div class="pickUp-method-displayer-text">
							{{ pickUpDisplayText }}
						</div>
						<div class="pickUp-method-displayer-text">{{ pickUpUserInfo }}</div>
						<div
							class="pickUp-method-displayer-text"
							v-if="pickUpMethod === 'DELIVERY'"
						>
							{{ userAddress }}
						</div>
					</div>
					<div class="icon-wrapper" v-if="pickUpMethodExist">
						<img
							class="edit-icon"
							src="@/assets/edit.svg"
							alt="edit pickup method"
						/>
					</div>
				</div>
			</div>
			<div class="center-page-minus">
				<div class="order-counts">
					<p>訂單總計 <span></span> ${{ $stepPrice(payableTotal) }}元</p>
					<div class="order-expend" @click="handleExpend">
						<img src="../../assets/back.svg" :class="hideStatus" alt="back" />
					</div>
				</div>
				<BySlider v-show="isShow">
					<div class="order-grid">
						<div class="order-items" v-for="(item, index) in cart" :key="index">
							<div class="order-name">{{ item.itemName }}</div>
							<div class="order-amount">x{{ item.count }}</div>
							<div class="order-price">
								${{ $stepPrice($countProductPrice(item)) }}
							</div>
							<OrderList :data="item" style="margin-top: 10px" />
							<!--商品自動折扣-->
							<div v-if="item.automaticDiscountId" class="order-item-discount">
								<p>折扣：</p>
								<div class="order-item-discount-content">
									<span>「{{ item.automaticDiscountName }}」 </span>
									<span
										>-${{ Math.trunc(item.discountPrice * item.count) }}</span
									>
								</div>
							</div>
						</div>
					</div>
				</BySlider>
			</div>
			<hr />

			<!--	訂單自動折扣	-->
			<template v-if="useOrderAutomaticDiscount">
				<div class="center-page-minus">
					<div class="order-discount">
						<div class="order-discount-use">
							<span v-if="useOrderAutomaticDiscount"
								>「{{ useOrderAutomaticDiscount.name }}」</span
							>
							<span v-if="orderAutomaticDiscountPrice > 0"
								>-${{ orderAutomaticDiscountPrice }}</span
							>
						</div>
						<div class="order-discount-capped" v-if="isDiscountCapped">
							折抵已達上限，應付 $0
						</div>
					</div>
				</div>
				<hr />
			</template>

			<div class="center-page-minus remark" v-if="!isKiosk">
				<div class="order-inputs">
					<p>訂單備註</p>
				</div>
				<div style="width: 100%">
					<ByInput
						type="textarea"
						variant="textareaBasic"
						:value="remark"
						@input="setRemark"
					/>
				</div>
			</div>
			<div class="center-page-minus">
				<div v-if="invoiceSwitch">
					<div class="get-time-title title tag-relative" ref="invoiceTypeRef">
						發票資訊
						<span>
							<span class="tag">*</span>
							<span class="validateText">
								{{ `必填` }}
							</span>
						</span>
					</div>
					<div v-if="errorValidate.invoiceType" class="error-validate mb-2">
						- 請選擇發票資訊
					</div>
					<div class="invoice-radio-group">
						<!-- 紙本發票（預設） -->
						<ByRadio
							name="paperInvoice"
							v-model="invoiceType"
							title="紙本發票"
							cantToggle
						/>
						<!-- 手機載具 -->
						<ByRadio
							name="phoneCarrier"
							v-model="invoiceType"
							title="載具條碼"
							cantToggle
						/>
						<!-- 開立有統一編號發票 -->
						<ByRadio
							name="uniformNumber"
							v-model="invoiceType"
							title="統一編號"
							cantToggle
							style="margin-bottom: 10px"
						/>
						<!-- 捐贈發票 -->
						<ByRadio
							name="donationNumber"
							v-model="invoiceType"
							title="捐贈碼"
							cantToggle
							style="margin-bottom: 10px"
						/>
					</div>
					<div
						v-if="invoiceType === 'phoneCarrier'"
						class="order-inputs-box"
						ref="phoneCarrierRef"
					>
						<div v-if="errorValidate.phoneCarrier" class="error-validate">
							- 請輸入手機載具
						</div>
						<div v-if="errorValidate.phoneCarrierFormat" class="error-validate">
							- {{ phoneCarrierErrorMessage }}
						</div>
						<div class="order-inputs-box padding-left-10">
							<by-input
								@focus="scrollToInput(e)"
								v-model="userPhoneCarrier"
								:max="8"
								placeholder="請輸入載具條碼"
								:class="{
									'error-input':
										errorValidate.phoneCarrier ||
										errorValidate.phoneCarrierFormat,
								}"
							/>
						</div>
					</div>
					<div
						v-if="invoiceType === 'uniformNumber'"
						class="order-inputs-box"
						ref="uniformNumberRef"
					>
						<div v-if="errorValidate.uniformNumber" class="error-validate">
							- 請輸入統編
						</div>
						<div
							v-if="errorValidate.uniformNumberFormat"
							class="error-validate"
						>
							- 統編格式不符
						</div>
						<div class="order-inputs-box padding-left-10">
							<by-input
								@focus="scrollToInput(e)"
								v-model="userUniformNumber"
								:max="8"
								placeholder="請輸入統一編號"
								inputMode="numeric"
								:class="{
									'error-input':
										errorValidate.uniformNumber ||
										errorValidate.uniformNumberFormat,
								}"
							/>
						</div>
					</div>
					<div
						v-if="invoiceType === 'donationNumber'"
						class="order-inputs-box"
						ref="donationNumberRef"
					>
						<div v-if="errorValidate.donationNumber" class="error-validate">
							- 請輸入捐贈碼
						</div>
						<div
							v-if="errorValidate.donationNumberFormat"
							class="error-validate"
						>
							- 捐贈碼格式不符
						</div>
						<div class="order-inputs-box padding-left-10">
							<by-input
								@focus="scrollToInput(e)"
								v-model="userDonationNumber"
								:max="7"
								placeholder="請輸入捐贈碼"
								inputMode="numeric"
								:class="{
									'error-input':
										errorValidate.donationNumber ||
										errorValidate.donationNumberFormat,
								}"
							/>
						</div>
					</div>
				</div>
			</div>

			<div class="center-page-minus kiosk-order-remark" v-if="isKiosk">
				<div class="kiosk-order-remark_title">訂單備註</div>
				<div class="kiosk-order-remark_content">
					{{ $store.state.kioskOrderRemark }}
				</div>
			</div>

			<template v-if="!isKiosk">
				<div style="height: 12px" />
				<div
					class="center-page-minus"
					v-if="
						isCashPaySwitch ||
						isLinePaySwitch ||
						isIPassPaySwitch ||
						isPxPaySwitch
					"
					ref="payMethodRef"
				>
					<div class="get-time-title title">
						付款方式
						<span>
							<span class="tag">*</span>
							<span class="validateText">
								{{ `必填` }}
							</span>
						</span>
					</div>
					<div v-if="errorValidate.payMethod" class="error-validate mb-2">
						- 請選擇付款方式
					</div>
					<ByRadio
						class="get-time-now"
						name="CASH"
						cantToggle
						v-model="payMethod"
						v-if="isCashPaySwitch"
					>
						<img
							src="../../assets/PayMethod-Cash.png"
							alt="CashPay"
							class="pay-method"
						/>
						<div style="width: 100%"></div>
					</ByRadio>

					<ByRadio
						class="get-time-now"
						name="LINE_PAY_ONLINE"
						cantToggle
						v-model="payMethod"
						v-if="isLinePaySwitch"
						:disabled="isFreeOrder"
					>
						<img
							src="../../assets/PayMethod-LinePay.png"
							alt="LinePay"
							:class="['pay-method', { disabled: isFreeOrder }]"
						/>
						<div style="width: 100%"></div>
					</ByRadio>

					<ByRadio
						class="get-time-now"
						name="IPASS_ONLINE"
						cantToggle
						v-model="payMethod"
						v-if="isIPassPaySwitch"
						:disabled="isFreeOrder"
					>
						<img
							src="../../assets/PayMethod-iPassMoney.png"
							alt="IPassOnline"
							:class="['pay-method', { disabled: isFreeOrder }]"
						/>
						<div style="width: 100%"></div>
					</ByRadio>

					<ByRadio
						class="get-time-now"
						name="PX_PAY_ONLINE"
						cantToggle
						v-model="payMethod"
						v-if="isPxPaySwitch"
						:disabled="isFreeOrder"
					>
						<img
							src="../../assets/PayMethod-PxPay.png"
							alt="PxPay"
							:class="['pay-method', { disabled: isFreeOrder }]"
						/>
						<div style="width: 100%"></div>
					</ByRadio>
				</div>
				<div style="height: 12px" />
				<hr />
			</template>
			<div class="center-page-minus">
				<div style="height: 96px" />
				<ByOrderControl
					:names="['返回', '送出訂單']"
					:events="[goBack, goMeal]"
				/>
			</div>
		</div>
		<ByDialog
			v-model="isFinishedOrderModal"
			:title="'完成訂購'"
			:closable="false"
		>
			<template v-if="!isKiosk">
				<p>您可於【我的訂單】頁面開啟取餐畫面, 並出示畫面取餐。</p>
				<p>請準備足夠的現金, 於取餐時付款。</p>
			</template>
			<p v-else>請領取您的取餐單據，並準備足夠的現金，於取餐時付款。</p>
			<template slot="dialog-footer">
				<div class="dialog-footer">
					<ByButton stl="main1" @click="goTakeMeal">確認</ByButton>
				</div>
			</template>
		</ByDialog>
		<ByCompareCartConfirm ref="compareCartConfirmRef" />
		<!-- TAG: 取餐方式的選擇跳窗 -->
		<PickupMethodDialog
			v-model="isPickupMethodShowing"
			width="465px"
			title="選擇取餐方式和時間"
			@cancel="handleCancelPickupMethod"
			@confirm="handlePickUpConfirm"
		/>
	</div>
</template>

<script>
import { isBookedSlotStillAvailable } from '@/utils/booking'
import {
	getOrderDetailList,
	getOrderPayableTotal,
	isDiscountCappedAtZero,
} from '@/utils/order'
import StepBar from '@/views/layout/StepBar.vue'
import BySlider from '@/components/BySlider.vue'
import OrderList from '@/views/buy/Components/OrderList.vue'
import ByInput from '@/components/Input.vue'
import ByRadio from '@/components/Radio.vue'
import ByVuePicker from '@/components/VuePicker.vue'
import ByCompareCartConfirm from '@/components/CompareCartConfirm.vue'
import ByDialog from '@/components/Dialog.vue'
import ByOrderControl from '@/components/OrderControl.vue'
import ByButton from '@/components/Button.vue'
import ByCheckbox from '@/components/Checkbox.vue'
import PickupMethodDialog from '@/components/PickupMethodDialog.vue'

export default {
	components: {
		ByButton,
		ByOrderControl,
		ByDialog,
		ByCompareCartConfirm,
		ByVuePicker,
		ByRadio,
		ByInput,
		OrderList,
		BySlider,
		StepBar,
		ByCheckbox,
		PickupMethodDialog,
	},
	data() {
		return {
			isMobile: false,
			isIOS: false,
			isAndroid: false,
			isShow: true,
			isFinishedOrderModal: false,
			isTableware: false,
			kioskFinishedOrderToStoreTimeout: null,
			payMethod: '',
			userName: '',
			userPhone: '',
			userAddress: '',
			invoiceType: '',
			userPhoneCarrier: '',
			phoneCarrierErrorMessage: '',
			userUniformNumber: '',
			userDonationNumber: '',
			remark: '',
			tableNumber: null,
			// NOTE: 這邊準備要棄用，改由 store 統一管理
			// pickUpMethod: 'DINE_IN',
			isPickupMethodShowing: false,
			errorValidate: {
				userName: false,
				userPhone: false,
				userPhoneFormat: false,
				userAddress: false,
				tableNumber: false,
				phoneCarrier: false,
				phoneCarrierFormat: false,
				uniformNumber: false,
				uniformNumberFormat: false,
				donationNumber: false,
				donationNumberFormat: false,
				payMethod: false,
				invoiceType: false,
			},
		}
	},
	computed: {
		qrCodeHash() {
			return this.$storeManager.qrCodeHash
		},
		storeId() {
			return this.$storeManager.storeId
		},
		// openInfo 初始為 null，且後端在店家合約狀態異常時會提前 return、不帶 invoiceSwitch，
		// 兩種情況都必須視為關閉（fail-closed），否則結帳頁會整頁拋 TypeError。
		invoiceSwitch() {
			const invoiceSwitch = this.$store.state.store.openInfo?.invoiceSwitch
			return !!(invoiceSwitch?.admin && invoiceSwitch?.store)
		},
		cart() {
			const cart = this.$store.getters['user/currCart'](this.qrCodeHash)
			return cart || []
		},
		cartTotal() {
			return this.$store.getters['user/cartTotal'](this.qrCodeHash) || 0
		},
		hideStatus() {
			return this.isShow ? 'order-hide' : 'order-show'
		},
		isKiosk() {
			return this.$store.getters.isKiosk
		},
		isCashPaySwitch() {
			const paymentSwitchesConfig =
				this.$store.state.store.openInfo.payMethod.mobileCashPay
			// 再來是根據 store 的方法，來去讀對應的值即可
			const currentSwitchName = {
				DINE_IN: 'dineInSwitch',
				SELF: 'pickupSwitch',
				DELIVERY: 'deliverySwitch',
			}
			return paymentSwitchesConfig[
				currentSwitchName[this.$store.state.user.pickUpMethod]
			]
		},
		isLinePaySwitch() {
			if (
				!this.$store.state.store.openInfo.payMethod?.mobileLinePay?.methodSwitch
			) {
				return false
			}
			const paymentSwitchesConfig =
				this.$store.state.store.openInfo.payMethod.mobileLinePay
			// 再來是根據 store 的方法，來去讀對應的值即可
			const currentSwitchName = {
				DINE_IN: 'dineInSwitch',
				SELF: 'pickupSwitch',
				DELIVERY: 'deliverySwitch',
			}
			return paymentSwitchesConfig[
				currentSwitchName[this.$store.state.user.pickUpMethod]
			]
		},
		isIPassPaySwitch() {
			if (
				!this.$store.state.store.openInfo.payMethod?.mobileIpass?.methodSwitch
			) {
				return false
			}
			const paymentSwitchesConfig =
				this.$store.state.store.openInfo.payMethod.mobileIpass
			// 再來是根據 store 的方法，來去讀對應的值即可
			const currentSwitchName = {
				DINE_IN: 'dineInSwitch',
				SELF: 'pickupSwitch',
				DELIVERY: 'deliverySwitch',
			}
			return paymentSwitchesConfig[
				currentSwitchName[this.$store.state.user.pickUpMethod]
			]
		},
		isPxPaySwitch() {
			// 舊版後端不會回傳 mobilePxPay，optional chaining 讓它安全降級為不顯示
			if (
				!this.$store.state.store.openInfo.payMethod?.mobilePxPay?.methodSwitch
			) {
				return false
			}
			const paymentSwitchesConfig =
				this.$store.state.store.openInfo.payMethod.mobilePxPay
			// 再來是根據 store 的方法，來去讀對應的值即可
			const currentSwitchName = {
				DINE_IN: 'dineInSwitch',
				SELF: 'pickupSwitch',
				DELIVERY: 'deliverySwitch',
			}
			return paymentSwitchesConfig[
				currentSwitchName[this.$store.state.user.pickUpMethod]
			]
		},
		payableTotal() {
			return getOrderPayableTotal(
				this.cartTotal,
				this.orderAutomaticDiscountPrice,
			)
		},
		isDiscountCapped() {
			return isDiscountCappedAtZero(
				this.cartTotal,
				this.orderAutomaticDiscountPrice,
			)
		},
		// 實收為 0 的訂單：線上付款不適用，畫面禁用與可用清單共用此判斷。
		// 判準是折抵後的應付金額 —— 折前有金額、折後為 0 的訂單同樣送不進金流
		isFreeOrder() {
			return this.payableTotal <= 0
		},
		// 實際可用的付款方式：後台開關為真，且線上付款需訂單金額大於 0。
		// 初始化、送出驗證與畫面禁用條件共用這一份，避免自動選中畫面上點不動的方式。
		// 零元且店家只開線上付款時清單為空，訂單送不出去 —— 為刻意行為，
		// 讓使用者回報店家，店家才會察覺該配置組合有問題。
		availablePayMethods() {
			const isFree = this.isFreeOrder
			return [
				{ key: 'CASH', enabled: this.isCashPaySwitch },
				{ key: 'LINE_PAY_ONLINE', enabled: this.isLinePaySwitch && !isFree },
				{ key: 'IPASS_ONLINE', enabled: this.isIPassPaySwitch && !isFree },
				{ key: 'PX_PAY_ONLINE', enabled: this.isPxPaySwitch && !isFree },
			]
				.filter(method => method.enabled)
				.map(method => method.key)
		},
		mobilePickupMethod() {
			return this.$store.state.store.openInfo.mobilePickupMethod
		},
		// 訂單自動折扣金額(折數換算金額、金額)
		orderAutomaticDiscountPrice() {
			// 只有在訂單確認頁面才會特別檢查購物車內有無贈品
			if (!this.freeItemDiscountValid) {
				return 0
			}
			const storeId = this.storeId
			if (!storeId) return 0
			return this.$store.getters['user/orderAutomaticDiscountPriceByStore'](
				storeId,
			)
		},
		// 套用的訂單自動折扣
		useOrderAutomaticDiscount() {
			// 只有在訂單確認頁面才會特別檢查購物車內有無贈品
			if (!this.freeItemDiscountValid) {
				return null
			}
			const storeId = this.storeId
			if (!storeId) return null
			return this.$store.getters['user/useOrderAutomaticDiscountByStore'](
				storeId,
			)
		},
		cartHasFreeItem() {
			return this.$store.getters['user/currCartHasFreeItem'](this.qrCodeHash)
		},

		freeItemDiscountValid() {
			const storeId = this.storeId
			if (!storeId) return false
			const orderDiscount =
				this.$store.getters['user/useOrderAutomaticDiscountByStore'](storeId)

			if (!orderDiscount) {
				return false
			}

			// 如果折扣類型是 FREE_ITEM，但購物車內沒有贈品，則無效
			return !(
				orderDiscount.discountType === 'FREE_ITEM' && !this.cartHasFreeItem
			)
		},
		pickUpDisplayText() {
			return this.$store.getters['user/pickUpDisplayText']
		},
		pickUpMethodExist() {
			return !!this.pickUpMethod
		},
		pickUpMethod() {
			return this.$store.state.user.pickUpMethod
		},
		currentMethodSwitches() {
			const switches = this.$store.state.store?.openInfo?.mobilePickupMethod
			switch (this.pickUpMethod) {
				case 'DINE_IN':
					return switches?.dineIn
				case 'SELF':
					return switches?.self
				case 'DELIVERY':
					return switches?.delivery
				default:
					return null
			}
		},
		pickUpUserInfo() {
			const showName = this.currentMethodSwitches?.nameSwitch && this.userName
			const showPhone =
				this.currentMethodSwitches?.phoneSwitch && this.userPhone
			const parts = []
			if (showName) parts.push(`${this.userName}先生/小姐`)
			if (showPhone) parts.push(this.userPhone)
			return parts.join('，')
		},
		// 根據當前取餐方式與後台 switch 動態組訂單個資 payload，
		// 未啟用的欄位一律傳空字串，避免帶到 store 殘留的舊資料
		orderUserPayload() {
			const sw = this.currentMethodSwitches
			const isDineIn = this.pickUpMethod === 'DINE_IN'
			const isDelivery = this.pickUpMethod === 'DELIVERY'
			return {
				name: sw?.nameSwitch ? this.userName : '',
				phone: sw?.phoneSwitch ? this.userPhone : '',
				address: isDelivery ? this.userAddress : '',
				tableNumber:
					isDineIn && sw?.tableNumberSwitch
						? this.$store.state.user.tableNumber
						: '',
			}
		},
	},
	watch: {
		userName(newValue, oldValue) {
			if (newValue) {
				this.errorValidate.userName = false
			}
		},
		userPhone(newValue, oldValue) {
			const regex = /^[0-9\s]*$/
			if (!regex.test(newValue)) {
				this.$nextTick(() => {
					this.userPhone = ''
				})
			}

			if (newValue) {
				this.errorValidate.userPhone = false
				this.errorValidate.userPhoneFormat = false
			}
		},
		tableNumber(newValue, oldValue) {
			if (newValue) {
				this.errorValidate.tableNumber = false
			}
		},
		userAddress(newValue, oldValue) {
			if (newValue) {
				this.errorValidate.userAddress = false
			}
		},
		userPhoneCarrier(newValue, oldValue) {
			if (newValue) {
				this.errorValidate.phoneCarrier = false
				this.errorValidate.phoneCarrierFormat = false
			}
		},
		userUniformNumber(newValue, oldValue) {
			if (newValue) {
				this.errorValidate.uniformNumber = false
				this.errorValidate.uniformNumberFormat = false
			}
		},
		userDonationNumber(newValue, oldValue) {
			if (newValue) {
				this.errorValidate.donationNumber = false
				this.errorValidate.donationNumberFormat = false
			}
		},
	},

	created() {},
	mounted() {
		// 檢查是否有待顯示的訊息（來自路由守衛）
		const pendingAlert = this.$store.state.pendingAlert
		if (pendingAlert) {
			this.$alert(pendingAlert.message, pendingAlert.type)
			this.$store.commit('clearPendingAlert')
		}

		this.initUserInfo()
		this.initPayMethod()
		this.isMobile =
			/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
				navigator.userAgent,
			)
		this.isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent)
		this.isAndroid = /Android/i.test(navigator.userAgent)
	},
	methods: {
		// TAG: 處理取餐方式的選擇器點擊事件
		handlePickupMethodClick() {
			this.isPickupMethodShowing = true
		},
		handleCancelPickupMethod() {
			// 取消選擇取餐方式時的處理（目前無需特別處理）
		},
		handlePickUpConfirm(pickUpDraft) {
			this.$store.dispatch('user/confirmPickupMethod', pickUpDraft)

			// 同步更新本地 data（用於後續提交訂單）
			if (pickUpDraft.userName) this.userName = pickUpDraft.userName
			if (pickUpDraft.phone) this.userPhone = pickUpDraft.phone
			if (pickUpDraft.address) this.userAddress = pickUpDraft.address
		},
		setRemark(value) {
			this.remark = value
		},
		scrollToRequiredInput(refName) {
			const element = this.$refs[refName]
			if (element) {
				document.documentElement.scrollTo({
					top: element.offsetTop,
					behavior: 'smooth',
				})
			}
		},
		scrollToInput(e) {},
		transformDayRangeText(date1, date2) {
			const r = date1 - date2
			if (r >= 0 && r < 86400000) return '今天'
			else if (r >= 86400000 && r < 172800000) return '明天'
			else if (r >= 172800000 && r < 259200000) return '後天'
			return ''
		},
		handleExpend() {
			this.isShow = !this.isShow
		},
		goTakeMeal() {
			if (this.isKiosk) {
				clearTimeout(this.kioskFinishedOrderToStoreTimeout)
				return this.$router.replace(`/${this.qrCodeHash}/Store`)
			}

			this.$api.order.getOrderInfo({}).then(res => {
				const {
					data: { hashId },
				} = res
				this.$router.push(`/${this.qrCodeHash}/TakeMeal/${hashId}`)
			})
		},
		goBack() {
			this.$router.go(-1)
		},
		validName(pickUp) {
			const { nameSwitch } = pickUp
			if (nameSwitch) {
				if (!this.userName || !this.userName?.length) {
					return true
				}
			}
			return false
		},
		validPhone(pickUp) {
			const { phoneSwitch } = pickUp
			if (phoneSwitch) {
				if (!this.userPhone || !this.userPhone?.length) {
					this.errorValidate.userPhone = true
					return '請輸入手機號碼'
				}
				if (!/^[0-9]{10}$/g.test(this.userPhone)) {
					this.errorValidate.userPhoneFormat = true
					return '手機號碼格式不符'
				}
			}
			return null
		},
		// 手機點餐 發送新增訂單api
		async goMeal() {
			if (!this.invoiceType && this.invoiceSwitch) {
				this.errorValidate.invoiceType = true
				this.scrollToRequiredInput('invoiceTypeRef')
				return this.$alert('請選擇發票資訊', 'danger')
			} else {
				this.errorValidate.invoiceType = false
			}

			if (this.invoiceType === 'phoneCarrier') {
				if (!this.userPhoneCarrier) {
					this.errorValidate.phoneCarrier = true
					this.scrollToRequiredInput('phoneCarrierRef')
					return this.$alert('請輸入手機載具', 'danger')
				} else if (!this.checkPhoneCarrier(this.userPhoneCarrier)) {
					this.errorValidate.phoneCarrierFormat = true
					this.phoneCarrierErrorMessage = '手機載具格式不符'
					this.scrollToRequiredInput('phoneCarrierRef')
					return this.$alert('手機載具格式不符', 'danger')
				}

				try {
					const res = await this.$api.order.checkPhoneCarrier({
						storeId: this.storeId,
						phoneCarrier: this.userPhoneCarrier,
					})

					if (res && res.status === false) {
						this.errorValidate.phoneCarrierFormat = true
						this.phoneCarrierErrorMessage = '查無此手機載具'
						this.scrollToRequiredInput('phoneCarrierRef')
						return this.$alert('查無此手機載具', 'danger')
					}
				} catch (e) {
					this.errorValidate.phoneCarrierFormat = true
					this.phoneCarrierErrorMessage = '手機載具驗證失敗'
					this.scrollToRequiredInput('phoneCarrierRef')
					return this.$alert('手機載具驗證失敗', 'danger')
				}
			}

			if (this.invoiceType === 'uniformNumber') {
				if (!this.userUniformNumber) {
					this.errorValidate.uniformNumber = true
					this.scrollToRequiredInput('uniformNumberRef')
					return this.$alert('請輸入統編', 'danger')
				} else if (!this.checkUniformNumber(this.userUniformNumber)) {
					this.errorValidate.uniformNumberFormat = true
					this.scrollToRequiredInput('uniformNumberRef')
					return this.$alert('統編格式不符', 'danger')
				}
			}

			if (this.invoiceType === 'donationNumber') {
				if (!this.userDonationNumber) {
					this.errorValidate.donationNumber = true
					this.scrollToRequiredInput('donationNumberRef')
					return this.$alert('請輸入捐贈碼', 'danger')
				} else if (!this.checkDonationNumber(this.userDonationNumber)) {
					this.errorValidate.donationNumberFormat = true
					this.scrollToRequiredInput('donationNumberRef')
					return this.$alert('捐贈碼格式不符', 'danger')
				}
			}

			if (!this.payMethod || !this.checkPayMethod(this.payMethod)) {
				this.errorValidate.payMethod = true
				this.scrollToRequiredInput('payMethodRef')
				return this.$alert('請選擇付款方式', 'danger')
			} else {
				this.errorValidate.payMethod = false
			}

			// NOTE: 防止使用者在這個頁面換成外送之後，沒有滿足最低消費金額
			if (this.pickUpMethod === 'DELIVERY') {
				const minAmount =
					this.$store.state.store?.openInfo?.mobilePickupMethod?.delivery
						?.deliveryMinimumAmount
				const cartTotal =
					this.$store.getters['user/cartTotal'](this.qrCodeHash) || 0
				if (cartTotal < minAmount) {
					return this.$alert('未滿足最低消費金額', 'danger')
				}
			}

			if (!this.checkPickupTimeStillBookable()) {
				return
			}

			const { isTableware, cart } = this
			const storeId = this.$storeManager.storeId

			// Kiosk 模式下，CompareCartConfirm 會處理訂單並顯示 loading
			// 非 Kiosk 模式下，才需要 Order.vue 的 loading
			// 使用局部變量記錄，避免執行過程中 isKiosk 狀態改變導致邏輯錯誤
			const shouldControlLoading = !this.isKiosk

			try {
				if (shouldControlLoading) {
					this.$loading.show({
						message: '訂單送出中...',
						showResult: false,
					})
				}

				const cartConfirmAwait =
					await this.$refs.compareCartConfirmRef.confirm()

				if (!cartConfirmAwait) {
					if (shouldControlLoading) {
						this.$loading.hide()
					}
					return
				}
				// compareCart 期間可能收到折扣推播（ready 被打回 false），送單前再確認一次
				if (!this.$refs.compareCartConfirmRef.ensureAutomaticDiscountReady()) {
					if (shouldControlLoading) {
						this.$loading.hide()
					}
					return
				}
				if (!this.$store.state.socket.stompClient?.connected) {
					throw '連線失敗，請稍等片刻後再嘗試'
				}

				let takeTime = null
				const orderDetailList = getOrderDetailList(cart)
				const takeTimeData = this.$store.getters['user/pickUpTime']()
				if (takeTimeData) {
					const d = new Date(takeTimeData.date)
					const year = d.getFullYear()
					const month = String(d.getMonth() + 1).padStart(2, '0')
					const day = String(d.getDate()).padStart(2, '0')
					const takeTimeDate = `${year}-${month}-${day}`
					const takeTimeTime = takeTimeData.time.split(':').join(':')
					takeTime = `${takeTimeDate} ${takeTimeTime}`
				} else {
					takeTime = null
				}

				await this.$store
					.dispatch('socket/addOrder', {
						storeId,
						tableware: isTableware,
						orderDetailList: orderDetailList,
						remark: this.isKiosk
							? this.$store.state.kioskOrderRemark
							: this.remark,
						takeTime,
						payMethod: this.payMethod,
						...this.orderUserPayload,
						phoneCarrier:
							this.invoiceType === 'phoneCarrier' ? this.userPhoneCarrier : '',
						uniformNumber:
							this.invoiceType === 'uniformNumber'
								? this.userUniformNumber
								: '',
						donationNumber:
							this.invoiceType === 'donationNumber'
								? this.userDonationNumber
								: '',
						discountPrice: 0,
						entertain: false,
						paid: false,
						pickUpMethod: this.pickUpMethod,
						deliveryCheckStatus: this.$store.state.user.deliveryCheckStatus,
					})
					.then(res => {
						this.$store.state.kioskOrderRemark = ''
						this.remark = ''
						if (this.isKiosk) {
							this.$store.commit('user/SET_CART_ITEM', [])
							this.$store.commit('user/CLEAR_CURRENT_ORDER_AUTOMATIC_DISCOUNT') // 清除自動折扣
							sessionStorage.removeItem('category')
							sessionStorage.removeItem('xPosition')
							sessionStorage.removeItem('yPosition')

							clearTimeout(this.kioskFinishedOrderToStoreTimeout)
							this.kioskFinishedOrderToStoreTimeout = setTimeout(() => {
								this.$router.replace(`/${this.qrCodeHash}/Store`)
							}, 5000)
							return
						}

						this.$store.commit('user/SET_USER_NAME', this.userName)
						this.$store.commit('user/SET_USER_PHONE', this.userPhone)

						this.$store.commit('user/SET_GUEST_USER_PREFERENCES', {
							address: this.userAddress,
							phoneCarrier: this.userPhoneCarrier,
							uniformNumber: this.userUniformNumber,
							donationNumber: this.userDonationNumber,
						})

						sessionStorage.removeItem('category')
						sessionStorage.removeItem('xPosition')
						sessionStorage.removeItem('yPosition')

						const {
							data: {
								id,
								hashId,
								transactionStatus,
								paymentStatus,
								message,
								webPaymentUrl,
								appPaymentUrl,
							},
						} = res

						if (shouldControlLoading) {
							this.$loading.done()
						}

						if (paymentStatus === null) {
							this.$store.commit('user/SET_CART_ITEM', [])
							this.$store.commit('user/CLEAR_CURRENT_ORDER_AUTOMATIC_DISCOUNT') // 清除自動折扣
							this.$store.commit('myOrder/SET_FINISH_ORDER', true)
							// NOTE: 送出成功後，清空取餐方式的選擇和所有相關紀錄（除電話和姓名）
							this.$store.commit('user/RESET_PICKUPMETHOD')
							this.$store.commit('user/CLEAR_PICKUP_SELECTIONS')
							if (hashId) {
								this.$router.push(`/${this.qrCodeHash}/TakeMeal/${hashId}`)
							} else {
								this.$router.push(`/${this.qrCodeHash}/TakeMeal/${id}`)
							}
						} else if (paymentStatus === 'TO_BE_CONFIRMED') {
							window.location.href = webPaymentUrl
						} else {
							this.$alert(message, 'danger')
							this.$store.commit('user/SET_CART_ITEM', [])
							this.$store.commit('user/CLEAR_CURRENT_ORDER_AUTOMATIC_DISCOUNT') // 清除自動折扣
							this.$router.replace(`/${this.qrCodeHash}/Store`)
						}
					})
					.catch(async err => {
						if (shouldControlLoading) {
							this.$loading.done()
						}

						await this.$refs.compareCartConfirmRef?.handleAddOrderError(err)
					})
			} catch (err) {
				if (shouldControlLoading) {
					this.$loading.done()
				}

				await this.$refs.compareCartConfirmRef?.handleAddOrderError(err)
			}
		},
		/**
		 * 取餐表單是彈窗，關閉後就沒有 watch 在盯著時段清單：店家中途調整預約
		 * 設定或時段額滿時，已選時間會靜靜留著並送出店家排程裡不存在的時段
		 * （後端只擋過去時間）。送出前以最新設定再驗一次，失效就清掉並請客人重選。
		 */
		checkPickupTimeStillBookable() {
			const takeTimeData = this.$store.getters['user/pickUpTime']()
			if (!takeTimeData) {
				return true
			}

			const openInfo = this.$store.state.store.openInfo
			const stillBookable = isBookedSlotStillAvailable(
				openInfo?.bookingTimeList,
				takeTimeData.date,
				takeTimeData.time,
				openInfo?.minimumBookInterval || 0,
			)
			if (!stillBookable) {
				this.$store.commit('user/SET_PICKUP_TIME', null)
				this.$alert('您選的取餐時間已無法預約，請重新選擇', 'danger')
			}
			return stillBookable
		},
		/**
		 * 檢查營業人統一編號：
		 * 1. 統一編號預估空號將於 2024 年用罄，故擴增統一編號。
		 * 2. 為相容新舊統一編號，檢查邏輯由可被『10』整除改為可被『5』整除。
		 *
		 * @param uniformNo		統一編號，型別需為String
		 * @returns {boolean}	檢查結果
		 */
		checkUniformNumber(uniformNo) {
			uniformNo = uniformNo.trim()
			if (uniformNo.length === 0) {
			}

			const pattern = /^\d{8}$/
			if (!pattern.test(uniformNo)) {
				return false
			}

			let isLegal = false
			const weight = '12121241'
			let the7thNumberIs7 = false
			let sum = 0
			for (let i = 0; i < 8; i++) {
				const tmp = parseInt(uniformNo.charAt(i)) * parseInt(weight.charAt(i))
				sum += Math.floor(tmp / 10) + (tmp % 10) // 取出十位數和個位數相加
				if (i === 6 && uniformNo.charAt(i) === '7') {
					the7thNumberIs7 = true
				}
			}

			if (the7thNumberIs7) {
				if (sum % 5 === 0 || (sum + 1) % 5 === 0) {
					isLegal = true
				}
			} else {
				if (sum % 5 === 0) {
					isLegal = true
				}
			}

			return isLegal
		},
		/**
		 * 檢查手機載具條碼格式
		 * @param code 手機載具條碼字串
		 * @returns {boolean}
		 */
		checkPhoneCarrier(code) {
			// 不能為空
			if (!code) return false
			// 8碼，開頭/，後面7碼限定格式
			const pattern = /^\/[0-9A-Z.+-]{7}$/

			return pattern.test(code)
		},
		/**
		 * 檢查捐贈碼格式
		 * @param code 捐贈碼字串
		 * @returns {boolean}
		 */
		checkDonationNumber(code) {
			if (!code) return false
			// 3~7碼數字
			const pattern = /^\d{3,7}$/
			return pattern.test(code)
		},
		initUserInfo() {
			this.userName = this.$store.state.user.userName
			this.userPhone = this.$store.state.user.userPhone

			const guestPrefs = this.$store.state.user.guestUserPreferences
			this.userAddress = guestPrefs.address
			this.userPhoneCarrier = guestPrefs.phoneCarrier
			this.userUniformNumber = guestPrefs.uniformNumber
			this.userDonationNumber = guestPrefs.donationNumber
		},
		initPayMethod() {
			const methods = this.availablePayMethods
			if (methods.length === 1) {
				this.payMethod = methods[0]
			}
		},
		checkPayMethod(payMethod) {
			return this.availablePayMethods.includes(payMethod)
		},
	},
	beforeRouteEnter(to, from, next) {
		next(vm => {
			const { cart } = vm
			if (cart.length === 0) {
				next(`/${to.params.random}/Store`)
			}
		})
	},
}
</script>

<style lang="sass" scoped>
@import '@/utils/style.sass'
.pickUp-method-wrapper
	position: relative
	padding: 0% 5%
	margin-bottom: 10px
	color: #294B70
	.pickUp-method-displayer
		position: relative
		border: 2px solid #294B70
		font-weight: bold
		padding: 15px
		border-radius: 8px
		text-align: center
		.icon-wrapper
			+size(20px)
			position: absolute
			right: 0
			top: 50%
			transform: translate(-50%, -50%)
		.pickUp-method-displayer-text
			font-weight: 800
			margin-bottom: 10px
			&:last-child
				margin-bottom: 0
		&.--method-exist
			text-align: left

.remark
	border-bottom: 1px solid #D8D8D899
	padding-bottom: 10px !important
	margin-bottom: 10px !important

.addFullscreen
	position: fixed
	width: 100%
	height: 100%
	left: 0
	top: 0
	background: rgba(#000, 0.5)
	z-index: 3

.container
	margin-bottom: 130px

.get-time-title
	font-size: 18px
	font-weight: bold
	padding: 10px 0 15px
	position: relative

.get-time-now
	margin-bottom: 15px

.pay-method
	max-width: 6rem
	height: auto

	&.disabled
		filter: grayscale(100%)
		opacity: 0.5


.get-time-time
	flex-wrap: wrap

.get-time-time-content
	width: 100%
	padding-top: 10px

//.get-time-time-range
//  display: flex
//  align-items: center
//  width: 100%
//  > *
//    width: 50%
//    &:first-child
//      margin-right: 8px

.get-time-time-content-date-select
	margin-bottom: 10px

.order
	&-discount
		margin: 10px 0

		&-use
			color: #f37201
			display: flex
			justify-content: space-between

		// 折抵吃滿整筆時的說明，避免客人以為畫面算錯
		&-capped
			margin-top: 6px
			color: #f37201
			font-size: 14px
			text-align: right

	&-inputs
		height: 20px
		font-size: 18px
		font-weight: bold
		margin: 12px 0

		&-box
			margin-bottom: 10px

			&::v-deep
				input
					padding-left: 95px

			&.padding-left-10
				&::v-deep
					input
						padding-left: 10px

	&-counts
		display: flex
		align-items: center
		justify-content: space-between
		height: 20px
		font-size: 18px
		font-weight: bold
		margin: 10px 0 20px 0

		p
			span
				display: inline-block
				background-color: #e2e5ec
				position: relative
				top: 3px
				width: 1px
				height: 18px
				margin: 0 10px

	&-expend
		height: 18px
		width: 18px
		margin-left: 50px

		img
			transition: all 0.3s
			transform: rotate(-90deg)
			width: 100%
			height: 100%

			&.order-show
				transform: rotate(90deg)

	&-grid
		transition: all 0.5s
		font-size: 16px

	&-items
		display: flex
		flex-wrap: wrap
		padding: 20px 0
		border-top: 1px solid #D8D8D899

	&-name
		min-width: 58.5%
		padding-right: 10px

	&-price
		flex: 1
		text-align: right
		color: #432d2c

	&-amount
		min-width: 25%
		font-weight: 900
		font-size: 16px
		color: #432d2c

	&-item-discount
		color: #f37201
		width: 100%
		font-size: 14px

		&-content
			margin-left: 12px
			margin-top: 7px
			display: flex
			justify-content: space-between

	&-information
		padding-top: 20px
		border-bottom: 1px solid #D8D8D899

		p
			font-size: 18px
			font-weight: bold
			margin-bottom: 20px

		.by-input
			margin-bottom: 20px
			display: block

	&-table
		padding-top: 20px

.here, .left
	margin-top: 20px

::v-deep .by-checkbox
	label
		width: 100% !important

hr
	width: 100%
	height: 1px
	border: 0
	background-color: #D8D8D899

.kiosk-order-remark
	padding-top: 16px

	&_title
		margin-bottom: 8px

	&_content
		line-height: 1.3
		font-weight: 400
		font-size: 14px

.error-validate
	font-size: 12.5px
	color: red

.error-input
	border: 2px solid red
	border-radius: 50px

.error-select
	border: 2px solid red

.mb-2
	margin-bottom: 8px

.tag
	font-size: 12.5px
	font-weight: bold
	color: red
	position: absolute

.validateText
	color: red
	margin-left: 5px
	font-size: 12.5px
	font-weight: normal

.invoice-radio-group
	display: flex
	flex-wrap: wrap
	width: fit-content
	gap: 10px

	> *
		flex: 0 0 45%
</style>
